import { useNavigation } from "@react-navigation/native";
import background from "assets/images/backgroundRotated.png";
import theme from "assets/theme";
import React, { useCallback, useContext, useState } from "react";
import {
  Button,
  Image,
  StyleSheet,
  Text,
  useWindowDimensions,
  View,
} from "react-native";
import AuthService from "services/Auth.service";
import { validateEmail } from "shared/utils/validator.utils";
import { SCREEN_ADMIN_LOGIN } from "web/constants";
import CustomLink from "webComponentsFormElements/CustomLink.component";
import Overlay from "webComponentsFormElements/Overlay.component";
import LabelInput from "webComponentsFormElements/inputs/LabelInput.component";
import { ToastContext } from "webContext/Toast.context";

const classes = StyleSheet.create({
  root: {
    width: "100vw",
    height: "100vh",
    justifyContent: "center",
    alignItems: "center",
    overflow: "hidden",
  },
  bgImage: {
    position: "absolute",
    opacity: 0.9,
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  card: {
    alignSelf: "flex-end",
    backgroundColor: "rgba(49, 120, 170, 1)",
    borderLeftColor: "rgb(110, 182, 234)",
    borderLeftWidth: 2,
    height: "100%",
    paddingBottom: "20%",
    minWidth: 500,
    width: "20%",
    paddingHorizontal: 20,
    justifyContent: "space-between",
    alignItems: "center",
  },
  headerText: {
    fontSize: 28,
    color: theme.color.white,
  },
  formContainer: {
    width: "70%",
    height: "50%",
    gap: 24,
    alignItems: "center",
  },
  section: {
    width: "100%",
    alignItems: "center",
    gap: 18,
  },
  buttonContainer: {
    marginTop: 32,
    width: "100%",
  },
  backContainer: {
    width: "100%",
    padding: 20,
    alignItems: "flex-start",
  },
});

export default function ForgotPassword() {
  const { showToast } = useContext(ToastContext);

  const [hasReset, setHasReset] = useState(false);
  const [email, setEmail] = useState("");

  const navigation = useNavigation();
  const width = useWindowDimensions().width;
  const handleReset = useCallback(async () => {
    try {
      await AuthService.forgotPassword(email);
      showToast(
        "If this email is associated with an organization, a password reset request was sent. Please check your inbox for further instructions.",
        "success",
      );
      setHasReset(true);
    } catch {
      showToast("An error occurred while sending the recovery email.", "error");
    }
  }, [email, showToast]);

  const stateClasses = StyleSheet.create({
    card: {
      ...classes.card,
      ...(width <= 500
        ? {
            alignSelf: "center",
            width: "100%",
            minWidth: "auto",
          }
        : {
            alignSelf: "flex-end",
          }),
    },
  });

  return (
    <View style={classes.root}>
      <Image source={background} resizeMode="cover" style={classes.bgImage} />
      <View style={stateClasses.card}>
        <Overlay />

        <View style={classes.backContainer}>
          <CustomLink
            variant="white"
            linkText="Back"
            navigateTo={SCREEN_ADMIN_LOGIN}
          />
        </View>

        <View style={classes.formContainer}>
          <View style={classes.section}>
            <Text style={classes.headerText}>Forgot Password</Text>
            <LabelInput
              variant="white"
              label="Email"
              required
              disabled={hasReset}
              value={email}
              onChangeText={setEmail}
              hasErrorOnBlur={email !== "" && !validateEmail(email)}
            />
          </View>

          <View style={classes.buttonContainer}>
            <Button
              title={hasReset ? "Back" : "Reset"}
              color={theme.color.primary}
              disabled={!validateEmail(email)}
              onPress={() =>
                hasReset
                  ? navigation.navigate(SCREEN_ADMIN_LOGIN)
                  : handleReset()
              }
            />
          </View>
        </View>
      </View>
    </View>
  );
}
